import React, { useState } from "react";
import { KpiNames, MapBound } from "lib/api";

interface MapContextValue {
  refreshTimestamp: number;
  setRefreshTimestamp: (timestamp: number) => void;
  typeIds: string[];
  setTypeIds: (typeIds: string[]) => void;
  mapBound?: MapBound;
  setMapBound: (mapBound: MapBound) => void;
  incidentIds: string[];
  setIncidentIds: (ids: string[]) => void;
  listViewMode: boolean;
  setListViewMode: (value: boolean) => void;
  selectedKpi: KpiNames;
  setSelectedKpi: (value: KpiNames) => void;
}

export const MapContext = React.createContext<MapContextValue>({
  refreshTimestamp: 0,
  setRefreshTimestamp: () => undefined,
  typeIds: [],
  setTypeIds: () => undefined,
  mapBound: undefined,
  setMapBound: () => undefined,
  incidentIds: [],
  setIncidentIds: () => undefined,
  listViewMode: false,
  setListViewMode: () => undefined,
  selectedKpi: "",
  setSelectedKpi: () => undefined,
});

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [refreshTimestamp, setRefreshTimestamp] = useState<number>(0);
  const [typeIds, setTypeIds] = useState<string[]>([]);
  const [mapBound, setMapBound] = useState<MapBound>();
  const [incidentIds, setIncidentIds] = useState<string[]>([]);
  const [listViewMode, setListViewMode] = useState<boolean>(false);
  const [selectedKpi, setSelectedKpi] = useState<KpiNames>("");

  return (
    <MapContext.Provider
      value={{
        refreshTimestamp,
        setRefreshTimestamp,
        typeIds,
        setTypeIds,
        mapBound,
        setMapBound,
        incidentIds,
        setIncidentIds,
        listViewMode,
        setListViewMode,
        selectedKpi,
        setSelectedKpi,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};
